export default __webpack_public_path__ + "static/media/stereo_09.7f2dcea6.gif";